export default __webpack_public_path__ + "static/media/icon.eed2470d.svg";